var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarShift = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 1.66699V4.16699",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 1.66699V4.16699",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.91699C16.1083 3.06699 17.5 4.12533 17.5 8.04199V13.192C17.5 16.6253 16.6667 18.342 12.5 18.342H7.5C3.33333 18.342 2.5 16.6253 2.5 13.192V8.04199C2.5 4.12533 3.89167 3.07533 6.66667 2.91699H13.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2918 14.667H2.7085",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 6.875C8.97484 6.875 8.10817 7.43333 8.10817 8.51667C8.10817 9.03333 8.34984 9.425 8.7165 9.675C8.20817 9.975 7.9165 10.4583 7.9165 11.025C7.9165 12.0583 8.70817 12.7 9.99984 12.7C11.2832 12.7 12.0832 12.0583 12.0832 11.025C12.0832 10.4583 11.7915 9.96667 11.2748 9.675C11.6498 9.41667 11.8832 9.03333 11.8832 8.51667C11.8832 7.43333 11.0248 6.875 9.99984 6.875ZM9.99984 9.24167C9.5665 9.24167 9.24984 8.98333 9.24984 8.575C9.24984 8.15833 9.5665 7.91667 9.99984 7.91667C10.4332 7.91667 10.7498 8.15833 10.7498 8.575C10.7498 8.98333 10.4332 9.24167 9.99984 9.24167ZM9.99984 11.6667C9.44984 11.6667 9.04984 11.3917 9.04984 10.8917C9.04984 10.3917 9.44984 10.125 9.99984 10.125C10.5498 10.125 10.9498 10.4 10.9498 10.8917C10.9498 11.3917 10.5498 11.6667 9.99984 11.6667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarShift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar-shift.41e420ae.svg";
export { ForwardRef as ReactComponent };